export const isDevMode = () => {
  return import.meta.env.VITE_PUBLIC_ENVIRONMENT === 'dev';
};

export const isProdMode = () => {
  return import.meta.env.VITE_PUBLIC_ENVIRONMENT === 'prod';
};
